// these mirror values in _constants.scss

export const PHONE_MAX = 667



// WEBPACK FOOTER //
// ./assets/j/src/constants.js